import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ActivityCondition} from "../../models/activity-condition";
import {ActivityConditionType} from "../../models/activity-condition-type";
import {Institution} from "../../models/institution";
import {Law} from "../../models/laws";
import {Registration} from "../../models/registration";
import {RegistrationActivityCondition} from "../../models/registration-activity-condition";

@Directive()
@Injectable()
export class ActivityConditionService {

  public serviceId: string;
  public registration: Registration;
  public activityCondition: ActivityCondition;
  public registrationActivityCondition: RegistrationActivityCondition;
  public laws: Law[] = [];
  public activityConditionTypes: ActivityConditionType[] = [];
  public addNew: boolean;
  public showDeterminantBuilder: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      activityCondition: this.activityCondition,
      registrationActivityCondition: this.registrationActivityCondition,
      laws: this.laws,
      activityConditionTypes: this.activityConditionTypes,
      addNew: this.addNew,
      showDeterminantBuilder: this.showDeterminantBuilder,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
